module.exports = __webpack_public_path__ + "static/media/play-button.98a330d3.png";